import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight, Brain, MessageSquare, Users2, Zap, Target, HeartHandshake } from 'lucide-react';

const trainings = [
  {
    id: 'stresszkezeles',
    icon: Brain,
    title: 'Stresszkezelés',
    description: 'Tanuld meg felismerni a stressz jeleit, és sajátíts el hatékony technikákat a kezelésére. A nyugalom nem luxus, hanem eszköz.',
  },
  {
    id: 'targyalastechnika',
    icon: MessageSquare,
    title: 'Tárgyalástechnika',
    description: 'Értsd meg a tárgyalás dinamikáját, és szerezz magabiztosságot bármilyen üzleti helyzetben. A jó megállapodás mindenki számára előnyös.',
  },
  {
    id: 'asszertiv-kommunikacio',
    icon: Users2,
    title: 'Asszertív kommunikáció',
    description: 'Fejezd ki magad határozottan, de tiszteletteljesen. Az asszertivitás nem agresszió, hanem önmagad és mások egyidejű tisztelete.',
  },
  {
    id: 'tranzakcioanalizis',
    icon: Zap,
    title: 'Tranzakcióanalízis',
    description: 'Fedezd fel a kommunikáció rejtett mintázatait. Értsd meg, miért beszélsz el egymás mellett, és hogyan kerülheted ezt el.',
  },
  {
    id: 'disc',
    icon: Target,
    title: 'DISC személyiségtípusok',
    description: 'Ismerd meg saját stílusodat, és tanuld meg olvasni másokat. A hatékony együttműködés az eltérő típusok megértésén alapul.',
  },
  {
    id: 'vevőkezeles',
    icon: HeartHandshake,
    title: 'Vevőkezelés',
    description: 'Alakíts ki tartós ügyfélkapcsolatokat. A vevőkezelés nem manipuláció, hanem valódi értékteremtés és figyelem.',
  },
];

export const TrainingCards = () => {
  return (
    <section id="kepzesek" className="section-padding relative" data-testid="trainings-section">
      <div className="absolute inset-0 z-0">
        <img loading="lazy" src="https://images.pexels.com/photos/3184325/pexels-photo-3184325.jpeg?auto=compress&cs=tinysrgb&w=1920" alt="Csapatmunka az Akadémia készségfejlesztő tréningén" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#07516B]/85" />
      </div>
      <div className="container-custom relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false, amount: 0.3 }}
          className="max-w-3xl mb-16"
        >
          <p className="text-[#FBAF3F] font-mono text-sm tracking-widest uppercase mb-4">
            Képzéseink
          </p>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-semibold text-white mb-6 drop-shadow-lg">
            Készségek, amelyek számítanak
          </h2>
          <p className="text-white/80 text-lg">
            Minden tréningünk gyakorlati fókuszú. Nem elég tudni — alkalmazni kell. 
            Válaszd ki a számodra legfontosabb területet.
          </p>
        </motion.div>

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 md:gap-8">
          {trainings.map((training, idx) => (
            <Link
              key={idx}
              to={`/jelentkezes?kepzes=${training.id}`}
              className="block"
            >
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: false, amount: 0.3 }}
                transition={{ delay: idx * 0.1, duration: 0.6 }}
                className="training-card card-dark group cursor-pointer hover:scale-[1.02] transition-transform duration-300 h-full"
                data-testid={`training-card-${idx}`}
              >
                <div className="w-10 h-10 md:w-12 md:h-12 bg-[#FBAF3F]/20 flex items-center justify-center mb-3 md:mb-5 group-hover:bg-[#FBAF3F]/30 transition-colors">
                  <training.icon size={20} className="text-[#FBAF3F] md:hidden" />
                  <training.icon size={24} className="text-[#FBAF3F] hidden md:block" />
                </div>
                <h3 className="font-heading text-base md:text-xl font-semibold text-white mb-3 break-words hyphens-auto">
                  {training.title}
                </h3>
                <p className="text-white/70 text-xs md:text-sm leading-relaxed break-words hyphens-auto">
                  {training.description}
                </p>
              </motion.div>
            </Link>
          ))}
        </div>

        {/* CTA Block */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false, amount: 0.3 }}
          className="mt-10 md:mt-16 p-6 md:p-12 card-dark border border-white/15 flex flex-col md:flex-row items-center justify-between gap-4 md:gap-8"
          data-testid="training-cta-block"
        >
          <div>
            <h3 className="font-heading text-2xl md:text-3xl font-semibold text-white mb-3">
              Nem tudod, melyik képzés illik hozzád?
            </h3>
            <p className="text-white/60">
              Segítünk megtalálni a számodra legmegfelelőbb programot. Foglalj ingyenes konzultációt.
            </p>
          </div>
          <Link
            to="/#kapcsolat"
            className="btn-primary flex items-center gap-2 whitespace-nowrap group"
            data-testid="training-cta-button"
          >
            Lépj velünk kapcsolatba
            <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
          </Link>
        </motion.div>
      </div>
    </section>
  );
};
